export const PARTS_FORM_NAME = 'LOGPART';
export const PART_INVENTORY_SUBFORM_NAME = 'LOGCOUNTERS';
export const PART_PARENT_DEFAULT_FIELDS = [
    'PARTNAME',
    'PARTDES',
    'EPARTDES',
    'FAMILYNAME',
    'FAMILYDES',
    'PUNITNAME'
];

export const UNIT_FIELD_NAME = 'UNITNAME4';
const BALANCE_FIELD_NAME = 'BALANCE';

export const IMG_FIELD_NAME = 'EXTFILENAME';
export const DEFAULT_OPTIONAL_FIELDS = [UNIT_FIELD_NAME, IMG_FIELD_NAME, BALANCE_FIELD_NAME];
export const FAMILY_FIELD_NAME = 'FAMILYNAME';
export const FAMILY_DESC_NAME = 'FAMILYDESC';
export const FAMILY_EDESC_NAME = 'EFAMILYDES';
export const NOT_INT_USE = 'INACTIVE';
export const FAMILY_FORM_NAME = 'FAMILY_LOG';
export const PART_INVENTORY_FIELDS = [BALANCE_FIELD_NAME, 'SELLBALANCE', 'DIFF', UNIT_FIELD_NAME];
export const NAME_TO_KEY_MAP = {
    PARTNAME: 'partName',
    PARTDES: 'description',
    EPARTDES: 'ePartdescription',
    FAMILYNAME: 'family',
    FAMILYDES: 'familyName',
    PUNITNAME: 'punitName'
};

export const INACTIVE_FIELD_NAME = 'INACTIVEFLAG';
export const INACTIVE_FAMILY_FIELD_NAME = 'INACTIVE';
export const PART_FIELD_NAME = 'PARTNAME';
export const TQUANT_FIELD_NAME = 'TQUANT';

export const SELECTED_FIELDS_STORE_KEY = 'parts_modal_selected_fields';

export const FETCH_BULK_TOP = 10;

//ui elements names
export const INVENTORY_BUTTON_NAME = 'inventory_button';
export const PART_CHECKBOX_NAME = 'PART_CHECKBOX_NAME';
export const SEARCH_INPUT_NAME = 'SEARCH_INPUT_NAME';
export const SEARCH_BUTTON_NAME = 'SEARCH_BUTTON_NAME';
export const ADD_QUANTITY_FIELD = 'ADD_QUANTITY_FIELD';

//Queries keys

const PART_PREFIX_KEY = 'PARTS_MODAL_';
export const INITIAL_QUERY = 'INITIAL_QUERY';
export const DETAILS_QUERY_KEY = PART_PREFIX_KEY + 'DETAILS';
export const INV_COLUMNS_QUERY_KEY = PART_PREFIX_KEY + 'INV_COLUMNS_QUERY_KEY';
export const PAGES_COUNT_QUERY = 'PAGES_COUNT_QUERY';
export const START_FORM_QUERY = 'START_FORM_QUERY';
export const START_COUNT_FORM_QUERY = 'PAGES_COUNT_QUERY';
export const INVENTORY_INFO_QUERY_KEY = 'INVENTORY_INFO_QUERY';
export const PARTS_COLUMNS_QUERY = 'PARTS_COLUMNS_QUERY';

// Monitor consts (including part search):
export const PARTS_SEARCH_MONITOR = 'ChooseParts_';
export const PARTS_SEARCH_MONITOR_EXPAND = 'Expand';
export const PARTS_SEARCH_MONITOR_CHANGEQUANTITY = 'ChangeQuantity';
export const PARTS_SEARCH_MONITOR_VIEWINV = 'ViewInv';
export const PARTS_SEARCH_MONITOR_ADD = 'Add';
export const PARTS_SEARCH_MONITOR_SEARCHBUTTON = 'SearchButton';
export const PARTS_SEARCH_MONITOR_FAMILYFILTER = 'FamilyFilter';
export const PARTS_SEARCH_MONITOR_SETTINGS = 'Settings';
export const PARTS_SEARCH_MONITOR_SETTINGS_SAVE = 'SettingsSave';
